
/* injects from baggage-loader */

import { Form } from "./Form";

import red from '_images/forms/red-circle.png';
import blue from '_images/forms/blue-circle.png';
import yellow from '_images/forms/yellow-circle.png';

import { FormColors, FormTypes } from '../../index.const';

export class Circle extends Form{
    constructor(x, y, angle, size, color){
        super(x, y, angle, size, color);

        this.type = FormTypes.circle;

        switch (color) {
            case FormColors.red:
                this.image = red;
                break;
        
            case FormColors.blue:
                this.image = blue;
                break;
            case FormColors.yellow:
                this.image = yellow;
                break;    
            default:
                break;
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/core/models/Circle.js